module.exports = __webpack_public_path__ + "media/images/award-solid-7cb2bfdee6665a9c659d749afa36e28b.svg";